





























import { Component, Mixins } from "vue-property-decorator";
import GeneralMixin from "@/mixin";
import { Action, Getter } from "vuex-class";
import ImageList from "@/components/customer/list/ImageList.vue";
import { ISite } from "@/types/site";
import { IUser } from "@/types/user";

@Component({
  components: { ImageList }
})
export default class extends Mixins<GeneralMixin>(GeneralMixin) {
  @Action("site/customerGet")
  public getSite!: (id: number) => void;
  @Getter("site/single")
  public site!: ISite;
  @Getter("auth/me")
  public user!: IUser;

  //   public site_id = this.user.site_id;

  public created() {
    this.getSite(this.user.site_id);
  }
}
